import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { openDialog, closeDialog } from '../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { OperacionesMovimientosView } from '../components/OperacionesMovimientosView'
import { OperacionEliminarFinDeLlenado } from '../OperacionEliminarFinDeLlenado/containers/OperacionEliminarFinDeLlenado'
import { OperacionEliminarInicioDeLlenado } from '../OperacionEliminarInicioDeLlenado/containers/OperacionEliminarInicioDeLlenado'
import { OperacionEliminarVaciado } from '../OperacionEliminarVaciado/containers/OperacionEliminarVaciado'
import { OperacionFinDeLlenado } from '../OperacionFinDeLlenado/containers/OperacionFinDeLlenado'
import { OperacionInicioDeLlenado } from '../OperacionInicioDeLlenado/containers/OperacionInicioDeLlenado'
import { OperacionModificarInicioDeLlenado } from '../OperacionModificarInicioDeLlenado/containers/OperacionModificarInicioDeLlenado'
import { OperacionVaciado } from '../OperacionVaciado/containers/OperacionVaciado'

export const OperacionesMovimientos = connect(null, { openDialog, closeDialog })(
  memo(({ silo, openDialog, closeDialog }) => (
    <OperacionesMovimientosView
      silo={silo}
      openDialogInicioLlenado={() => openDialog(() => <OperacionInicioDeLlenado silo={silo} />, 'INICIO_DE_LLENADO_SILO')}
      openDialogModificarInicioLlenado={() => openDialog(() => <OperacionModificarInicioDeLlenado silo={silo} />, 'MODIFICACION_INICIO_DE_LLENADO_SILO')}
      openDialogFinLlenado={() => openDialog(() => <OperacionFinDeLlenado silo={silo} />, 'FIN_LLENADO_SILO')}
      openDialogEliminarInicioLlenado={() => openDialog(() => <OperacionEliminarInicioDeLlenado silo={silo} />, 'ANULAR_INICIO_LLENADO_SILO')}
      openDialogEliminarFinLlenado={() => openDialog(() => <OperacionEliminarFinDeLlenado silo={silo} />, 'ANULAR_FIN_LLENADO_SILO')}
      openDialogEliminarVaciado={() => openDialog(() => <OperacionEliminarVaciado silo={silo} />, 'ANULAR_VACIADO_SILO')}
      openDialogVaciado={() => openDialog(() => <OperacionVaciado silo={silo} />, 'VACIADO_SILO')}
      cancelar={useCallback(() => {
        closeDialog('OPERACIONES_MOVIMIENTO_DE_SILO')
      }, [closeDialog])}
    />
  ))
)
